/**
 * Search functionality:
 * - First click on search icon: expand and focus input
 * - Second click on search icon: submit form
 */

import $ from "jquery";

$(document).ready(function () {
	// Handle each search form independently
	$(".header__search").each(function () {
		const $headerSearch = $(this);
		const $searchForm = $headerSearch.find(".search-form");
		const $searchInput = $headerSearch.find(".search__input");
		const $searchSubmit = $headerSearch.find(".search__submit");

		// When input is focused, expand it
		$searchInput.on("focus", function () {
			$headerSearch.addClass("is-active");
		});

		// Handle submit button click
		$searchSubmit.on("click", function (e) {
			const isActive = $headerSearch.hasClass("is-active");

			if (!isActive) {
				// First click: expand and focus
				e.preventDefault();
				$headerSearch.addClass("is-active");
				setTimeout(() => {
					$searchInput.focus();
				}, 100);
			} else {
				// Second click: submit form
				// Let form submit normally (don't prevent default)
				// Only submit if there's a value
				if ($searchInput.val().trim()) {
					// Form will submit normally
					return true;
				} else {
					e.preventDefault();
					return false;
				}
			}
		});
	});

	// When clicking outside, collapse all active searches
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".header__search").length) {
			$(".header__search.is-active").each(function () {
				$(this).removeClass("is-active");
				$(this).find(".search__input").blur();
			});
		}
	});
});
